import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '日本区课程', href: '/category/zone-jp' },
    { label: '韩国区课程', href: '/category/zone-kr' },
    { label: '语言课程', href: '/category/language' },
    { label: '职场培训', href: '/category/career' },
  ],
  热门分类: [
    { label: '文化教育', href: '/category/culture' },
    { label: '学历提升', href: '/category/degree' },
    { label: '资格考试', href: '/category/exam' },
    { label: '关于我们', href: '/about' },
  ],
  联系方式: [
    { label: '邮箱：contact@jpek-edu.com', href: 'mailto:contact@jpek-edu.com' },
    { label: '电话：400-888-9999', href: 'tel:4008889999' },
    { label: '地址：北京市朝阳区建国路88号', href: '#' },
    { label: '周一至周五 9:00-18:00', href: '#' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200" role="contentinfo">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-global-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-900 whitespace-nowrap">
                日韩成人教育
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              日韩一区二区成人教育平台，汇聚日韩顶尖教育资源，
              为成人学习者提供语言、职场、文化等多元课程，
              助力每一位学习者实现自我提升。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">
                {title}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('mailto:') || link.href.startsWith('tel:') || link.href === '#' ? (
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 日韩一区二区成人教育 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}